import Vue from 'vue'
import Vuex from 'vuex'
import Constant from '@/const.js'

Vue.use(Vuex)

export default new Vuex.Store({

  /**
    * States
    */
    state: {
      env : {} ,
      // main theme
      theme : '' , 
      window : {} , 
      // main constant of project
      const: Constant , 
      // object containg all configurations of each dataviz (see main.js file or each json file in conf/)
      conf: {} , 
      // dictionnary, preload once to be used accross a website (see DatavizFilters or Database/Dictionnary page)
      dictionnary : {
        cancers : [] ,
        populations : []
      },
      registries : [] , 

      filters : {} , 
      extra_tabs : {} , 
      graphic : { title : '' , footnote : '' } ,

      // list of footnotes
      graphic_footnotes : [] , 
      // show regional footnote
      show_regional_footnote : false , 

      volume : 12 
    },

    /**
    * Mutations
    */
    mutations: {
      setEnv (state,env) {
          state.env = env
      },
      setWindow (state,window_) {
          state.window = window_
      },
      setTheme (state,theme) {
          state.theme = theme
      },
      setConst (state,const_) {
          state.const = const_
      },
      setConf(state,conf){
        state.conf = conf 
      },
      setVersion(state,version){
        state.version = version 
      },
      setWindow (state,window_) {
          state.window = window_
      },
      setDevice (state,device) {
          state.device = device
      },
      setDictionnay(state,dictionnary){
        state.dictionnary = dictionnary 
      },
      setRegistries(state,registries){
        state.registries = registries 
      },
      setFilters(state,filters){
        state.filters = filters 
      },
      setExtraTabs(state,extra_tabs){
        state.extra_tabs = extra_tabs 
      },
      setGraphic(state,graphic){
        state.graphic = graphic 
      },
      toggleRegionalFootnote(state,show){
        state.show_regional_footnote = show ; 
      },
      setGraphicFootnote(state,footenote){ 
        // let footnote_regional = ( state.filters.types == '0_1') ? "* Sub-national incidence data" : "* Sub-national data" ; 
        if ( state.graphic_footnotes.includes( footenote ) == false)
          state.graphic_footnotes.push( footenote ) ; 
      },
      clearGraphicFootnote(state){
        state.show_regional_footnote = false ; 
        state.graphic_footnotes = [] ; 
      },
      setVolume(state,volume){
        state.volume = volume 
      }
    },
    
    /**
    * Actions
    */
    actions: {
    
    }
})
